export { default } from './CategoryProductList';
